export default "__VITE_ASSET__BYYGnPME__"